import React from 'react';

const SlidesPreviewCard = ({ item }) => (
    <a href={`/slides/editor/${item.id}`}
       className="block bg-white rounded-lg shadow-xs border border-gray-200 p-4 hover:shadow-md transition-shadow">
        <p className="font-medium text-gray-800 truncate">{item.name}</p>
        <p className="text-xs text-gray-400 mt-1">
            Updated {new Date(item.updated_at).toLocaleDateString()}
        </p>
    </a>
);

export default SlidesPreviewCard;
